import { Outlet } from 'react-router-dom';
import FilterTableProvider from 'shell/hooks/use-filter-table/provider';

export const initialValuesSubscriber = {
  description: '',
  code: '',
  orders: {},
  page: 0,
  rowsPerPage: 10,
};

const SubscriberInitializer = (): React.ReactElement => {
  return (
    <FilterTableProvider initialValues={initialValuesSubscriber}>
      <Outlet />
    </FilterTableProvider>
  );
};

SubscriberInitializer.displayName = 'Event destination page initializer component';

export default SubscriberInitializer;
